module.exports = __webpack_public_path__ + "img/responsive hospitium-03.834a134e.jpg";